module.exports = __webpack_public_path__ + "static/icon-c422e9652cf7775236e5c1a588cddd70.png";